import React from "react";

interface Props {
  invoiceNumber: string;
  locked: server.dto.Locked
}

export const InvoiceNumber = (props: Props) => {
  const { invoiceNumber, locked } = props;

  if (locked === "locked") {
    return <div className="flex gap">
      <div>
        <i className="icon-lock" />
      </div>
      <div>{invoiceNumber}</div>
    </div>;
  }

  return <div>{invoiceNumber}</div>;
}



